import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {BehaviorSubject, combineLatest, Observable, of, Subscription}                from 'rxjs';
import {
  ApDynGridColumnConfigBase,
  ApDynGridColumnHideConfig
}                                                                             from '../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {
  ApDynGridPagerConfigBase
}                                                                             from '../../ap-dyngrids/config/ap-dyn-grid-pager-config-base';
import {ObjectFactory}                                                        from 'ts-tooling';
import {filter, map}                                                          from 'rxjs/operators';
import {MapViewMode}                                                          from '../../ap-interface';
import {
  ApDynGridStatusColumnConfig
}                                                                             from '../../ap-dyngrids/config/ap-dyn-grid-status-column-config';
import {
  ApDynGridPropertyColumnConfig,
  FilterType,
  PropertyTemplate
}                                                                             from '../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {
  ApDynGridGroupColumnConfig
}                                                                             from '../../ap-dyngrids/config/ap-dyn-grid-group-column-config';
import {
  ApDynGridPagerWizardButton,
  ApDynGridPagerWizardConfig,
  ApDynGridPagerWizardSection
}                                                                             from '../../ap-dyngrids/config/ap-dyn-grid-pager-wizard-config';
import {
  ApUtilService
}                                                                             from '../../ap-utils/service/ap-util.service';
import {
  FieldStore
}                                                                             from '../../stores/farm/field.store';
import {
  FormStore,
  IEntryComponent
}                                                                             from '../../stores/layout/form.store';
import {
  LanguageStore
}                                                                             from '../../stores/translation/language.store';
import {
  SettingsStore
}                                                                             from '../../stores/base-data/settings.store';
import {
  MapViewStore
}                                                                             from '../../stores/layout/mapview.store';
import {
  DriverStore
}                                                                             from '../../stores/docu/driver.store';
import {
  InstrumentStore
}                                                                             from '../../stores/docu/instrument.store';
import {
  MachineStore
}                                                                             from '../../stores/docu/machine.store';
import {GetRoundNumericPipe}                                                  from '../../ap-utils';
import {
  ApDateService
}                                                                             from '../../ap-core/services/ap-date-service';
import {
  ApDynComponentComponent
}                                                                             from '../../ap-dyncomponent/ap-dyncomponent.component';
import {
  ApNFertilizationShowComponentData,
  INFertilizationShowGridItem
}                                                                             from './ap-n-fertilization-show-configs/ap-n-fertilization-show-types';
import {
  ApDynGridEditColumnConfig
}                                                                             from '../../ap-dyngrids/config/ap-dyn-grid-edit-column-config';
import {
  ModalDialogStore
}                                                                             from '../../stores/dialog/modal.dialog.store';
import {
  ModalDialogButtonKeys,
  ModalDialogPresets
}                                                                             from '../../stores/dialog/modal.dialog.presets';
import {
  NFertilizationStore
}                                                                             from '../../stores/n-fertilization/n-fertilization.store';
import {
  IModalDialogResult
}                                                                             from '../../ap-interface/interfaces/ap-modaldialog-data.interface';
import {
  ApNFertilizationComponentService
}                                                                             from '../../n-fertilization/services/ap-n-fertilization-component.service';
import {
  ApNFertilizationCommonService
}                                                                             from '../../n-fertilization/services/ap-n-fertilization.common.service';
import {
  FertilizerStore
}                                                                             from '../../stores/base-data/fertilizer.store';
import {
  NFertilizationService
}                                                                             from '../../services/data/n-fertilization.service';
import {
  FertilizerService
}                                                                             from '../../services/data/fertilizer.service';
import {
  IContentNRelatedPlanBookStatisticValue
}                                                                             from '../../types/n-fertilization.types';
import {
  FertilizationManagementService
}                                                                             from '../../services/data/fertilization-management.service';
import {
  OperationModesEnum
}                                                                             from '../../stores/common/operation-modes.store';
import {
  GetRoundNumericPipeConfig
}                                                                             from '../../ap-utils/configs/get-round-numeric.pipe.config';
import {
  TimeAreaService
}                                                                             from '../../services/data/time-area.service';
import {
  TimeFormatPipe
}                                                                             from '../../ap-utils/pipes/ap-format-duration.pipe';
import {
  nameOf
}                                                                             from '../../ap-core/utils/ap-name-of';
import {
  FormatType
}                                                                             from '../../ap-utils/types/ap-format-duration.types';
import {
  ApTranslationService
}                                                                             from '../../ap-utils/service/ap-translation.service';
import {
  ApTooltipContentService
}                                                                             from '../../ap-utils/service/ap-tooltip-content.service';
import {
  ApElementType
}                                                                             from '../../ap-interface/enums/ap-elements-type.enum';
import INFertilizationPlanBook = Data.TaskManagement.INFertilizationPlanBook;
import {
  CropNameV2CrService
}                                                                             from '../../services/data/crop-namev2cr.service';
import {
  FarmCropV2CrStore
}                                                                             from '../../stores/base-data/farm.cropv2cr.store';

@Component({
  selector: 'ap-n-fertilization-show',
  template: `
    <ap-dyncomponent [loading$]="loading$"
                     [headerIcon]="'ap-icon-n-fertilization'"
                     [columns]="columns$ | async"
                     [items]="items$ | async"
                     [pager]="pager"
                     [selectable]="{checkboxOnly: false, mode: 'multiple'}"
    ></ap-dyncomponent>
  `,
  standalone: false
})
export class ApNFertilizationShowComponent implements OnInit, AfterViewInit, OnDestroy, IEntryComponent {
  /**
   * Implements IEntryComponent
   */
  public Caption$: BehaviorSubject<string> = new BehaviorSubject('Global__Show');
  @ViewChild(ApDynComponentComponent, {static: true}) dynComponent: ApDynComponentComponent;
  public columns$: Observable<ApDynGridColumnConfigBase[]> = of([]);
  public items$ = new BehaviorSubject<INFertilizationShowGridItem[]>([]);
  public loading$: Observable<boolean> = of(false);
  public pager: ApDynGridPagerConfigBase;

  @Input() public data: ApNFertilizationShowComponentData;
  private _data: ApNFertilizationShowComponentData;
  private _subscriptions: Subscription[] = [];
  private _halfViewMode$ = new BehaviorSubject<number>(0);
  private _halfViewModeChange = new EventEmitter<void>();

  constructor(private fertilizerStore: FertilizerStore,
              private farmCropV2CrStore: FarmCropV2CrStore,
              private cropNameV2CrService: CropNameV2CrService,
              private fieldStore: FieldStore,
              private formStore: FormStore,
              private languageStore: LanguageStore,
              private settingsStore: SettingsStore,
              private mapViewStore: MapViewStore,
              private driverStore: DriverStore,
              private instrumentStore: InstrumentStore,
              private machineStore: MachineStore,
              private modalDialogStore: ModalDialogStore,
              private modalDialogPresets: ModalDialogPresets,
              private nFertilizationStore: NFertilizationStore,
              private dateService: ApDateService,
              private timeAreaService: TimeAreaService,
              private fertilizerService: FertilizerService,
              private translationService: ApTranslationService,
              private nFertilizationService: NFertilizationService,
              private tooltipContentService: ApTooltipContentService,
              private nFertilizationCommonService: ApNFertilizationCommonService,
              private fertilizationManagementService: FertilizationManagementService,
              private nFertilizationComponentService: ApNFertilizationComponentService,
              private timeFormatPipe: TimeFormatPipe,
              private roundNumericPipe: GetRoundNumericPipe) {
  }

  public ngOnInit(): void {
    this._subscriptions.push(this._halfViewModeChange.subscribe(() => {
      if (this._halfViewMode$.value) {
        this._halfViewMode$.next(0);
      } else {
        this._halfViewMode$.next(1);
      }
    }));
    this.loading$ = combineLatest([
      this.languageStore.Loading$,
      this.settingsStore.Loading$,
      this.nFertilizationStore.Loading$
    ]).pipe(
      map(([languageLoading, settingsLoading]) => languageLoading || settingsLoading)
    );
    this._data = this.tryCopyComponentData(this.data);
    this.columns$ = this._getColumns();
    this.pager = this._getPager();
  }

  public ngAfterViewInit(): void {
    this._subscriptions.push(
      this.dynComponent.SelectedItems$.subscribe((items: INFertilizationShowGridItem[]) => {
        const fieldsToSelect: string[] = items.map(x => x.FieldId.toString());
        this.fieldStore.changeSelectedField(fieldsToSelect);
      })
    );
    this._subscriptions.push(
      this.items$.subscribe((items: INFertilizationShowGridItem[]): void => {
        const itemsToSelect = items.map(x => x.Id);
        this.dynComponent.dynGrid?.gridPaging?.setSelectedKeys(itemsToSelect);
      })
    );
    this._subscriptions.push(
      this.nFertilizationStore.Listen(x => x.planBooks).pipe(
        map(planBooks => {
          const planBooksToShow = this._data?.PlanBookIds ?? [];
          return planBooks.filter(x => planBooksToShow.some(id => x.Id === id) && this.fieldStore.getFieldById(x.FieldId));
        })
      ).subscribe(items => {
        if (!items || items.length <= 0) {
          this.items$.next([]);
          this._onClose();
          return;
        }
        setTimeout(() => this.items$.next(this._getItems(items)), 0);
      })
    );
  }

  public ngOnDestroy(): void {
    this._subscriptions.forEach(x => x.unsubscribe());
  }

  private _onClose(): void {
    this.fieldStore.changeSelectedField([]);
    this.formStore.closeForm();
  }

  private _getColumns(): Observable<ApDynGridColumnConfigBase[]> {
    return combineLatest([
      this.languageStore.SelectedLanguage$,
      this.settingsStore.FirstSetting$
    ]).pipe(
      filter(([language, setting]) => !!language && !!setting),
      map(([language, setting]) => {
        const mapHide = this.mapViewStore.Listen(s => s.mode).pipe(
          map((mapMode) => mapMode === MapViewMode.HIDE)
        );
        return [
          new ApDynGridStatusColumnConfig({
            field: 'Status',
            class: 'StatusClass',
            description: 'StatusDesc'
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Docu_Ini__Number',
            field: 'Nr',
            width: 60,
            hide: true,
            filterType: FilterType.NUMBER,
            cssClass: 'right'
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Docu_Ini_Subnumber',
            field: 'TNr',
            width: 60,
            hide: true,
            filterType: FilterType.NUMBER,
            cssClass: 'right'
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Docu_Ini__Number',
            field: 'NrTNr',
            width: 70,
            hide: new ApDynGridColumnHideConfig({
              selfHide: mapHide
            })
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Docu_Ini__Name',
            field: 'Name',
            width: 180,
            cssClass: 'left',
            sortIndex: 0
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Docu_Ini__Area',
            field: 'Area',
            width: 60,
            tooltip: (dataItem) => dataItem['Area'],
            template: PropertyTemplate.NUMBER,
            filterType: FilterType.NUMBER,
            filterable: true,
            pipes: [{
              pipe: this.roundNumericPipe,
              args: [setting.DigitsAfterDecimalPoint]
            }]
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Global__Crop',
            field: 'Crop',
            width: 100,
            cropColoring: true,
            hide: true
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Global__ECStageShort',
            field: 'ECStage',
            width: 40,
            hide: true,
            template: PropertyTemplate.NUMBER,
            filterType: FilterType.NUMBER,
            filterable: true
          }),
          new ApDynGridGroupColumnConfig({
            title: 'N__ChartTitleX',
            width: 225,
            hide: true,
            groupColumns: [
              new ApDynGridPropertyColumnConfig({
                title: 'Global__Avg_Symbol',
                field: 'Absorption.Average',
                width: 75,
                cssClass: 'right',
                filterType: FilterType.NUMBER,
                filterable: true,
                pipes: [{
                  pipe: this.roundNumericPipe,
                  args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
                }]
              }),
              new ApDynGridPropertyColumnConfig({
                title: 'Global__Min',
                field: 'Absorption.Min',
                width: 75,
                cssClass: 'right',
                filterType: FilterType.NUMBER,
                filterable: true,
                pipes: [{
                  pipe: this.roundNumericPipe,
                  args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
                }]
              }),
              new ApDynGridPropertyColumnConfig({
                title: 'Global__Max',
                field: 'Absorption.Max',
                width: 75,
                cssClass: 'right',
                filterType: FilterType.NUMBER,
                filterable: true,
                pipes: [{
                  pipe: this.roundNumericPipe,
                  args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
                }]
              })
            ]
          }),
          new ApDynGridGroupColumnConfig({
            title: 'Global__Nsensor_Unit',
            width: 225,
            hide: true,
            groupColumns: [
              new ApDynGridPropertyColumnConfig({
                title: 'Global__Avg_Symbol',
                field: 'Fertilization.Average',
                cssClass: 'right',
                dynCssClass: (dataItem) => this.nFertilizationComponentService.applyAdditionalStylesForFertilizationValues(dataItem),
                tooltip: (dataItem) => this.nFertilizationComponentService.tooltipForFertilizationValues(dataItem),
                filterType: FilterType.NUMBER,
                filterable: true,
                width: 75,
                pipes: [{
                  pipe: this.roundNumericPipe,
                  args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
                }]
              }),
              new ApDynGridPropertyColumnConfig({
                title: 'Global__Min',
                field: 'Fertilization.Min',
                width: 75,
                cssClass: 'right',
                dynCssClass: (dataItem) => this.nFertilizationComponentService.applyAdditionalStylesForFertilizationValues(dataItem),
                tooltip: (dataItem) => this.nFertilizationComponentService.tooltipForFertilizationValues(dataItem),
                filterType: FilterType.NUMBER,
                filterable: true,
                pipes: [{
                  pipe: this.roundNumericPipe,
                  args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
                }]
              }),
              new ApDynGridPropertyColumnConfig({
                title: 'Global__Max',
                field: 'Fertilization.Max',
                width: 75,
                cssClass: 'right',
                dynCssClass: (dataItem) => this.nFertilizationComponentService.applyAdditionalStylesForFertilizationValues(dataItem),
                tooltip: (dataItem) => this.nFertilizationComponentService.tooltipForFertilizationValues(dataItem),
                filterType: FilterType.NUMBER,
                filterable: true,
                pipes: [{
                  pipe: this.roundNumericPipe,
                  args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
                }]
              })
            ]
          }),
          new ApDynGridGroupColumnConfig({
            title: this._halfViewMode$.pipe(map((m) => m === 0 ? 'N__ChartTitleX' : 'Global__Nsensor_Unit')),
            hide: new ApDynGridColumnHideConfig({
              mapHide: false,
              selfHide: this.mapViewStore.Listen(s => s.mode).pipe(map((m) => m !== MapViewMode.NORMAL)),
            }),
            headerButtons: {
              nextClicked: this._halfViewModeChange,
              previousClicked: this._halfViewModeChange,
              nextDisabled: of(false),
              previousDisabled: of(false)
            },
            xlsExport: false,
            width: 225,
            groupColumns: [
              new ApDynGridPropertyColumnConfig({
                title: 'Global__Avg_Symbol',
                field: 'Absorption.Average',
                cssClass: 'right',
                filterType: FilterType.NUMBER,
                filterable: true,
                width: 75,
                hide: new ApDynGridColumnHideConfig({
                  mapHide: false,
                  selfHide: this._halfViewMode$.pipe(map((m) => m === 1))
                }),
                pipes: [{
                  pipe: this.roundNumericPipe,
                  args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
                }]
              }),
              new ApDynGridPropertyColumnConfig({
                title: 'Global__Min',
                field: 'Absorption.Min',
                cssClass: 'right',
                filterType: FilterType.NUMBER,
                filterable: true,
                width: 75,
                hide: new ApDynGridColumnHideConfig({
                  mapHide: false,
                  selfHide: this._halfViewMode$.pipe(map((m) => m === 1))
                }),
                pipes: [{
                  pipe: this.roundNumericPipe,
                  args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
                }]
              }),
              new ApDynGridPropertyColumnConfig({
                title: 'Global__Max',
                field: 'Absorption.Max',
                cssClass: 'right',
                filterType: FilterType.NUMBER,
                filterable: true,
                width: 75,
                hide: new ApDynGridColumnHideConfig({
                  mapHide: false,
                  selfHide: this._halfViewMode$.pipe(map((m) => m === 1))
                }),
                pipes: [{
                  pipe: this.roundNumericPipe,
                  args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
                }]
              }),
              new ApDynGridPropertyColumnConfig({
                title: 'Global__Avg_Symbol',
                field: 'Fertilization.Average',
                cssClass: 'right',
                dynCssClass: (dataItem) => this.nFertilizationComponentService.applyAdditionalStylesForFertilizationValues(dataItem),
                tooltip: (dataItem) => this.nFertilizationComponentService.tooltipForFertilizationValues(dataItem),
                filterType: FilterType.NUMBER,
                filterable: true,
                width: 75,
                hide: new ApDynGridColumnHideConfig({
                  mapHide: false,
                  selfHide: this._halfViewMode$.pipe(map((m) => m === 0))
                }),
                pipes: [{
                  pipe: this.roundNumericPipe,
                  args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
                }]
              }),
              new ApDynGridPropertyColumnConfig({
                title: 'Global__Min',
                field: 'Fertilization.Min',
                cssClass: 'right',
                dynCssClass: (dataItem) => this.nFertilizationComponentService.applyAdditionalStylesForFertilizationValues(dataItem),
                tooltip: (dataItem) => this.nFertilizationComponentService.tooltipForFertilizationValues(dataItem),
                filterType: FilterType.NUMBER,
                filterable: true,
                width: 75,
                hide: new ApDynGridColumnHideConfig({
                  mapHide: false,
                  selfHide: this._halfViewMode$.pipe(map((m) => m === 0))
                }),
                pipes: [{
                  pipe: this.roundNumericPipe,
                  args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
                }]
              }),
              new ApDynGridPropertyColumnConfig({
                title: 'Global__Max',
                field: 'Fertilization.Max',
                cssClass: 'right',
                dynCssClass: (dataItem) => this.nFertilizationComponentService.applyAdditionalStylesForFertilizationValues(dataItem),
                tooltip: (dataItem) => this.nFertilizationComponentService.tooltipForFertilizationValues(dataItem),
                filterType: FilterType.NUMBER,
                filterable: true,
                width: 75,
                hide: new ApDynGridColumnHideConfig({
                  mapHide: false,
                  selfHide: this._halfViewMode$.pipe(map((m) => m === 0))
                }),
                pipes: [{
                  pipe: this.roundNumericPipe,
                  args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
                }]
              })
            ]
          }),
          new ApDynGridGroupColumnConfig({
            title: 'Nutrients__Average_Amount_Goods',
            headerStyle: {'text-align': 'center'},
            hide: true,
            groupColumns: [
              new ApDynGridPropertyColumnConfig({
                title: '',
                field: nameOf<INFertilizationShowGridItem>('ProductAvg'),
                hide: true,
                width: 75,
                cssClass: 'right',
                filterType: FilterType.NUMBER,
                filterable: true,
                tooltip: (dataItem: INFertilizationShowGridItem) => this.nFertilizationCommonService.productAmountTooltip(
                  dataItem.ProductAvg, dataItem.ProductAvgUnit),
                pipes: [{pipe: this.roundNumericPipe, args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]}]
              }),
              new ApDynGridPropertyColumnConfig({
                title: '',
                field: nameOf<INFertilizationShowGridItem>('ProductAvgUnit'),
                hide: true,
                width: 50
              })
            ]
          }),
          new ApDynGridGroupColumnConfig({
            title: 'Global__Sum_Goods',
            headerStyle: {'text-align': 'center'},
            hide: true,
            groupColumns: [
              new ApDynGridPropertyColumnConfig({
                title: '',
                field: nameOf<INFertilizationShowGridItem>('ProductTotal'),
                hide: true,
                width: 75,
                cssClass: 'right',
                filterType: FilterType.NUMBER,
                filterable: true,
                tooltip: (dataItem: INFertilizationShowGridItem) => this.nFertilizationCommonService.productAmountTooltip(
                  dataItem.ProductTotal, dataItem.ProductTotalUnit),
                pipes: [{pipe: this.roundNumericPipe, args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]}]
              }),
              new ApDynGridPropertyColumnConfig({
                title: '',
                field: nameOf<INFertilizationShowGridItem>('ProductTotalUnit'),
                hide: true,
                width: 50
              })
            ]
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Base__SortItemDate',
            field: 'Date',
            format: language.DateFormat,
            hide: true,
            width: 80
          }),
          new ApDynGridGroupColumnConfig({
            title: 'Settings__Lbl_Menu_Resources',
            hide: true,
            groupColumns: [
              new ApDynGridPropertyColumnConfig({
                field: nameOf<INFertilizationShowGridItem>('DurationInMilliseconds'),
                title: `${this.translationService.translate('TotalTime')} [${this.translationService.translate('Base__UnitH')}]`,
                hide: true,
                width: 70,
                cssClass: 'right',
                headerFilterable: true,
                tooltip: (dataItem: INFertilizationShowGridItem) => this.tooltipContentService.getCapacityPerformanceTooltip(dataItem.HaPerHour),
                pipes: [{
                  pipe: this.timeFormatPipe,
                  args: [{
                    formatType: FormatType.Decimals,
                    suffixValue: 'Base__UnitH',
                    decimalsFormatOptions: {
                      decimalsCount: 1,
                      decimalsSeparator: language.DecimalSeperator
                    }
                  }]
                }]
              }),
              new ApDynGridPropertyColumnConfig({
                field: 'Machine.NameWithSign',
                title: 'Base__Engine',
                width: 100,
                hide: true,
              }),
              new ApDynGridPropertyColumnConfig({
                field: 'Instrument.Name',
                title: 'AgriConnect_Ini__Tool',
                width: 100,
                hide: true
              }),
              new ApDynGridPropertyColumnConfig({
                field: 'Driver.FirstNameFullName',
                title: 'Docu_Ini__Motorist',
                width: 100,
                hide: true
              })
            ]
          }),
          new ApDynGridEditColumnConfig({
            data: [
              {
                text: 'Global__Edit',
                callback: ApUtilService.createEventEmitter(this._editPlanBook.bind(this), this._subscriptions),
                disabled: true
              },
              {
                text: 'Global__Delete',
                callback: ApUtilService.createEventEmitter(this._deletePlanBook.bind(this), this._subscriptions),
                disabled: (dataItem: INFertilizationShowGridItem) => !!dataItem?.SourceItem?.BookedAt
              }
            ]
          })
        ];
      })
    );
  }

  private _getPager(): ApDynGridPagerWizardConfig {
    return new ApDynGridPagerWizardConfig(
      new ApDynGridPagerWizardButton('Global_Back_With_Arrow', ApUtilService.createEventEmitter(this._onClose.bind(this), this._subscriptions)),
      new ApDynGridPagerWizardSection(),
      new ApDynGridPagerWizardSection(),
      {
        formConfig: undefined
      }
    );
  }

  private _getItems(planBooks: INFertilizationPlanBook[]): INFertilizationShowGridItem[] {
    return planBooks.filter(planBook => {
      const isDeletedItem = planBook.DeletedBy !== null || planBook.DeletedAt !== null;
      const isBookedItem = planBook.BookedBy !== null || planBook.BookedAt !== null;
      return !isDeletedItem && (this._data.IsBooked ? isBookedItem : !isBookedItem);
    }).map(planBook => {
      const nApplications = this._getNApplication(planBook, this._data.IsBooked);
      const nUpTakes = this.nFertilizationService.getNUpTakes(planBook.RasterStatistics);
      const field = this.fieldStore.getFieldById(planBook.FieldId);
      const geom = this.fieldStore.getCurrentFieldGeom(field);
      const farmCrop = this.farmCropV2CrStore.findById(planBook.FarmCropId);
      const isBooked = planBook?.BookedAt !== null;
      const status = this.nFertilizationCommonService.getStatusForApplication(nApplications, nUpTakes,
        planBook.ECValue, farmCrop?.Crop?.CropType?.EppoCode, planBook.OperationMode, null, isBooked);
      const driver = this.driverStore.getDriverById(planBook.ExportDriver);
      const machine = this.machineStore.getMachineById(planBook.ExportMachine);
      const instrument = this.instrumentStore.getInstrumentById(planBook.ExportInstrument);
      const fertilizer = this.fertilizerStore.getFertilizer(planBook.ProductId);
      const productTotal = this._getAmount(planBook, geom.AreaHa, this._data.IsBooked);
      const productTotalUnit = this.fertilizerService.getFertilizerUnit(fertilizer, false);
      const productAvg = this.nFertilizationCommonService.calculateProductAvg(productTotal ?? undefined, geom.AreaHa);
      const productAvgUnit = this.fertilizerService.getFertilizerUnit(fertilizer, true);
      const haPerHour = this.timeAreaService.getHaPerHoursFromTotalMilliseconds(geom?.AreaHa,
        planBook.Duration?.TotalMilliseconds);
      return {
        Id: planBook.Id,
        Status: status.state,
        StatusClass: status.class,
        StatusDesc: status.description,
        Name: this.fieldStore.getFieldName(field),
        Nr: field.FieldNumber,
        TNr: field.FieldSubnumber,
        NrTNr: this.fieldStore.getFieldNumberAndSubNumber(field),
        FieldId: field.Id,
        Crop: this.cropNameV2CrService.getCropNameById(planBook.FarmCropId),
        Date: this.dateService.toFarmDateFromUtc(planBook.ApplicationDate).toDate(),
        Area: geom.AreaHa,
        ECStage: planBook.ECValue,
        ProductTotal: productTotal,
        ProductTotalUnit: Number.isFinite(productTotal) && productTotalUnit ? productTotalUnit : '-',
        ProductAvg: productAvg,
        ProductAvgUnit: Number.isFinite(productAvg) && productAvgUnit ? productAvgUnit : '-',
        FertilizerEfficiency: fertilizer?.Efficiency,
        Absorption: nUpTakes,
        Fertilization: nApplications,
        DurationInMilliseconds: planBook.Duration?.TotalMilliseconds,
        HaPerHour: haPerHour,
        Driver: driver,
        Machine: machine,
        Instrument: instrument,
        SourceItem: planBook
      } as INFertilizationShowGridItem;
    });
  }

  private _deletePlanBook(itemToDelete: INFertilizationShowGridItem): void {
    this.modalDialogStore.setModalDialogData(this.modalDialogPresets.DeleteDialog({
      resultDelegate: (dialogResult: IModalDialogResult): void => {
        if (dialogResult?.key === ModalDialogButtonKeys.Delete) {
          this.nFertilizationStore.DeleteNFertilizationPlanBooks([itemToDelete.SourceItem]);
        }
      }
    }));
  }

  private _getNApplication(planBook: INFertilizationPlanBook, isBooked: boolean): IContentNRelatedPlanBookStatisticValue | undefined {
    if (isBooked) {
      const nApplicationRange = this.nFertilizationService.getNApplications(planBook.RasterStatistics);
      if (nApplicationRange) {
        return {
          Min: nApplicationRange.Min,
          Max: nApplicationRange.Max,
          Average: nApplicationRange.Average
        };
      }
      return undefined;
    }
    let avg = planBook.BookedAt != null ? planBook.ApplicationRateWithFactor : planBook.ApplicationRate;
    avg = this.nFertilizationService.filterAvgValue(planBook.OperationMode, avg);
    let min = planBook.BookedAt != null ? planBook.ApplicationMinWithFactor : planBook.ApplicationMin;
    min = this.nFertilizationService.filterValue(planBook.OperationMode, min);
    let max = planBook.BookedAt != null ? planBook.ApplicationMaxWithFactor : planBook.ApplicationMax;
    max = this.nFertilizationService.filterValue(planBook.OperationMode, max);
    return {
      Min: Number.isFinite(min) ? min : undefined,
      Max: Number.isFinite(max) ? max : undefined,
      Average: Number.isFinite(avg) ? avg : undefined
    };
  }

  private _getAmount(planBook: INFertilizationPlanBook, areaHa: number, isBooked: boolean): number | undefined {
    if (!planBook || !areaHa) {
      return undefined;
    }

    const applicationRate = planBook.RasterStatistics?.[1]?.Mean ?? planBook.ApplicationRate ?? 0;
    if (isBooked) {
      const nApplicationRange = this.nFertilizationService.getNApplications(planBook.RasterStatistics);
      if (!Number.isFinite(nApplicationRange?.Average)) {
        return undefined;
      }
      return this.fertilizationManagementService.calculateProductAmount(
        planBook.ProductId, ApElementType.N,
        applicationRate,
        planBook.AreaHa ?? 0
      );
    }
    switch (planBook.OperationMode?.Key) {
      case OperationModesEnum.Constant:
      case OperationModesEnum.ApplicationMap:
      case OperationModesEnum.ApplicationMapAbsolute:
      case OperationModesEnum.NfTargetMapPerPlan:
      case OperationModesEnum.TargetValue:
        return this.fertilizationManagementService.calculateProductAmount(planBook.ProductId, ApElementType.N,
          applicationRate, areaHa);
      default:
        return undefined;
    }
  }

  private _editPlanBook(_: INFertilizationShowGridItem): void {
  }

  /**
   * Method with extended error handling while serializing the component's data.
   * Needed for further analysis of APV49-3984
   * @param updateComponentData
   * @private
   */
  private tryCopyComponentData(updateComponentData: any): ApNFertilizationShowComponentData {
    try {
      return ObjectFactory.Copy(updateComponentData);
    } catch (error) {
      let referenceCache = [];
      const duplicateReferenceKeys: string[] = [];
      JSON.stringify(updateComponentData, (key, value) => {
        if (typeof value === 'object' && value !== null) {
          if (referenceCache.includes(value)) {
            duplicateReferenceKeys.push(key);
            return;
          }
          referenceCache.push(value);
        }
        return value;
      });
      referenceCache = null;
      throw new Error(`Error while copy object with SummaryId '${updateComponentData?.DataItem?.Id}',
      duplicateReferenceKeys: ${JSON.stringify(duplicateReferenceKeys)}: ${error.message}`);
    }
  }
}
